import Amplify from 'aws-amplify';

const awsExports = {
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool
    identityPoolId: process.env.AWS_IDENTITY_POOL_ID,
    // REQUIRED - Amazon Cognito Region
    region: process.env.AWS_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.AWS_USER_POOL_ID,
    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: process.env.AWS_USER_POOL_WEB_CLIENT_ID,
  },
  API: {
    aws_appsync_graphqlEndpoint:
      process.env.AWS_APPSYNC_GRAPHQLENDPOINT_GETDATA,
    aws_appsync_region: process.env.AWS_REGION,
    aws_appsync_authenticationType:
      process.env.AWS_APPSYNC_AUTHENTICATIONTYPE,
    graphql_headers: async () => {
      const session = await Amplify.Auth.currentSession();
      return {
        Authorization: session.getIdToken().getJwtToken(),
      };
    },
  },
};

export default awsExports;
